const cdnUrl = 'https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files';
export const Icons = {
    Column: `${cdnUrl}/images/column.png`,
    Company: `${cdnUrl}/images/company.png`,
    Contact: `${cdnUrl}/images/contact.png`,
    Database: `${cdnUrl}/images/database.png`,
    Date: `${cdnUrl}/images/date.png`,
    DisabledContact: `${cdnUrl}/images/disabled-contact.png`,
    DisabledDocumentaryType: `${cdnUrl}/images/documentary-type-disabled.png`,
    DisabledEnterpriseApplication: `${cdnUrl}/images/enterprise-application-disabled.png`,
    DisabledExternalUser: `${cdnUrl}/images/external-user-disabled.png`,
    DisabledGroup: `${cdnUrl}/images/group-disabled.png`,
    DisabledOffice: `${cdnUrl}/images/office-disabled.png`,
    DisabledProfile: `${cdnUrl}/images/disabled-profile.png`,
    DisabledSerie: `${cdnUrl}/images/serie-disabled.png`,
    DisabledSerieSimple: `${cdnUrl}/images/disabled-serie-simple.png`,
    DisabledSystemTable: `${cdnUrl}/images/disabled-system-table.png`,
    DisabledTrd: `${cdnUrl}/images/trd-disabled.png`,
    DisabledUser: `${cdnUrl}/images/user-disabled.png`,
    DocumentaryType: `${cdnUrl}/images/documentary-type.png`,
    Docx: `${cdnUrl}/images/docx.png`,
    DropDown: `${cdnUrl}/images/dropdown.png`,
    EnterpriseApplication: `${cdnUrl}/images/enterprise-application.png`,
    ExternalUser: `${cdnUrl}/images/external-user.png`,
    File: `${cdnUrl}/images/file.png`,
    Flow: `${cdnUrl}/images/flow.png`,
    Folder: `${cdnUrl}/images/folder.png`,
    Form: `${cdnUrl}/images/form.png`,
    GanttChart: `${cdnUrl}/images/gantt-chart.png`,
    Group: `${cdnUrl}/images/group.png`,
    Link: `${cdnUrl}/images/link.png`,
    Mail: `${cdnUrl}/images/mail.png`,
    Office: `${cdnUrl}/images/office.png`,
    Outlook: `${cdnUrl}/images/mail.png`,
    Pdf: `${cdnUrl}/images/pdf.png`,
    Picture: `${cdnUrl}/images/picture.png`,
    Pptx: `${cdnUrl}/images/pptx.png`,
    Profile: `${cdnUrl}/images/profile.png`,
    Script: `${cdnUrl}/images/script.png`,
    Section: `${cdnUrl}/images/section.png`,
    Serie: `${cdnUrl}/images/serie.png`,
    SerieSimple: `${cdnUrl}/images/serie-simple.png`,
    SystemTable: `${cdnUrl}/images/system-table.png`,
    Table: `${cdnUrl}/images/table.png`,
    Time: `${cdnUrl}/images/time.png`,
    Trd: `${cdnUrl}/images/trd.png`,
    Txt: `${cdnUrl}/images/mail.png`,
    User: `${cdnUrl}/images/user.png`,
    UserFolder: `${cdnUrl}/images/user-folder.png`,
    Xlsx: `${cdnUrl}/images/xlsx.png`
};
